const formatDuration = (seconds) => {
  if (seconds == null) return '-'
  const total = Math.max(0, Math.floor(Number(seconds) || 0))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  if (hours > 0) return `${hours} ч ${minutes} мин`
  return `${minutes} мин`
}

export const mapRecognitionSessionRow = (row) => ({
  id: row.id,
  number: row.plateNumber || row.number || '',
  plateNumber: row.plateNumber || row.number || '',
  date: row.entranceTime || row.date || null,
  entranceTime: row.entranceTime || row.date || null,
  timeExit: row.exitTime || row.timeExit || null,
  exitTime: row.exitTime || row.timeExit || null,
  time: row.durationSeconds != null ? formatDuration(row.durationSeconds) : row.time || '-',
  durationSeconds: row.durationSeconds ?? null,
  type: row.type || '',
  paidAmount: row.paidAmount ?? row.amount ?? 0,
  amount: row.amount ?? 0,
  debt: row.debt ?? 0,
  status: row.status || '',
  isRepeat: Boolean(row.isRepeat),
  visitNumber: row.visitNumber ?? 1
})

export const normalizeRecognitionsReport = (response) => {
  if (!response) {
    return {
      summary: null,
      sessions: [],
      rows: [],
      meta: {}
    }
  }

  if (Array.isArray(response)) {
    const rows = response.map(mapRecognitionSessionRow)
    return {
      summary: null,
      sessions: rows,
      rows,
      meta: {}
    }
  }

  const sessions = Array.isArray(response.sessions) ? response.sessions : []
  const rows = sessions.map(mapRecognitionSessionRow)

  return {
    summary: response.summary || null,
    sessions: rows,
    rows,
    meta: {
      period: response.period || '',
      date: response.date || '',
      building: response.building || ''
    }
  }
}
